import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'nullDash',
    standalone: true
})
export class NullDashPipe implements PipeTransform {
    transform(value: any): any {
        return value === null || value === undefined || value === '' ? '-' : value;
    }
}
